import { is } from 'stdlib/is'

import DOM from '@common/DOM/DOM'

/** A teszt div mérete (px), amihez viszonyítunk. */
const TEST_SIZE = 100

/** BCR (getBoundingClientRect) kalibráció a ContentScale-hez. */
export default class BcrCalibration {
  /** Kalibrált korrekciós szorzó a BCR értékeihez. */
  private static correctionFactor: number | undefined

  /** Kalibrálja a BCR viselkedését az aktuális scale módhoz. */
  public static calibrate (): void {
    const root = document.querySelector('#root')

    if (!is.instanceOf(root, HTMLElement)) {
      return
    }

    const testDiv = document.createElement('div')

    testDiv.style.width         = `${ TEST_SIZE }px`
    testDiv.style.height        = `${ TEST_SIZE }px`
    testDiv.style.position      = 'absolute'
    testDiv.style.visibility    = 'hidden'
    testDiv.style.pointerEvents = 'none'

    root.appendChild(testDiv)

    const { width } = testDiv.getBoundingClientRect()

    DOM.remove(testDiv)

    // Headless (pl. jsdom) környezetben a BCR 0-t adhat vissza.
    if (width <= 0) {
      return
    }

    // Ha a BCR kompenzálja a zoom-ot: width ≈ TEST_SIZE → correctionFactor ≈ 1.
    // Ha nem kompenzálja: width ≈ TEST_SIZE * ratio → correctionFactor ≈ 1/ratio.
    BcrCalibration.correctionFactor = TEST_SIZE / width
  }

  /** Visszaadja a kalibrált korrekciós szorzót. Ha nincs kalibrálva, undefined. */
  public static getCorrectionFactor (): number | undefined {
    return BcrCalibration.correctionFactor
  }

  /** Teszteléshez: reseteli a kalibrációt. */
  public static reset (): void {
    BcrCalibration.correctionFactor = undefined
  }
}
